export default __webpack_public_path__ + "static/media/petgramImg_3.51633e73.png";